// Grußformel der E-Mail-Signatur (Kundenfeedback 11.09.26, I.).
//
// Die Signatur ist freies HTML; die Grußformel ist per Konvention die erste
// Textzeile ("Mit freundlichen Grüßen<br><br>…"). Damit sie ohne Fummelei im
// Editor änderbar ist, wird sie als eigenes Feld angeboten: Auswahl aus
// üblichen Formeln oder freier Text. Die Funktionen hier lesen bzw. ersetzen
// genau diese erste Zeile und lassen den Rest der Signatur unverändert.

export const CLOSING_OPTIONS: readonly string[] = [
  "Mit freundlichen Grüßen",
  "Freundliche Grüße",
  "Mit besten Grüßen",
  "Beste Grüße",
  "Viele Grüße",
  "Herzliche Grüße",
  "Mit freundlichem Gruß",
  "Kind regards",
  "Best regards",
];

/** Trennt die erste Zeile (bis zum ersten Zeilenumbruch-Tag) vom Rest. */
function splitFirstLine(html: string): { first: string; rest: string } {
  const match = /<br\s*\/?>|<\/p>|<\/div>/i.exec(html);
  if (!match) return { first: html, rest: "" };
  return { first: html.slice(0, match.index), rest: html.slice(match.index) };
}

function stripTags(html: string): string {
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .trim();
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/** Erkennt, ob eine Textzeile wie eine Grußformel aussieht. */
export function looksLikeClosing(text: string): boolean {
  const t = text.trim();
  if (!t) return false;
  if (/\{\{[a-z_]+\}\}/i.test(t)) return false; // Platzhalter-Zeile, z. B. Name
  return /gr(ü|u)(ß|ss)|gru(ß|ss)|regards|greetings|salutations|cordialement/i.test(t);
}

/**
 * Liefert die aktuelle Grußformel (erste Zeile), sofern sie wie eine
 * Grußformel aussieht – sonst einen leeren String.
 */
export function extractClosing(html: string): string {
  const { first } = splitFirstLine(html || "");
  const text = stripTags(first);
  return looksLikeClosing(text) ? text : "";
}

/**
 * Ersetzt die Grußformel in der ersten Zeile durch `closing`. Gibt es noch
 * keine, wird sie mit Leerzeile vorangestellt. Ein leerer Wert entfernt die
 * bisherige Grußformel samt Leerzeile.
 */
export function replaceClosing(html: string, closing: string): string {
  const source = html || "";
  const value = closing.trim();
  const { first, rest } = splitFirstLine(source);
  const hasClosing = looksLikeClosing(stripTags(first));

  if (!value) {
    if (!hasClosing) return source;
    return rest.replace(/^(<br\s*\/?>\s*){1,2}/i, "");
  }
  const line = escapeHtml(value);
  if (hasClosing) {
    // Formatierung der bisherigen Zeile (z. B. <strong>) bewusst verwerfen –
    // die Grußformel ist schlichter Text.
    return line + rest;
  }
  if (!stripTags(source)) return line;
  return `${line}<br><br>${source}`;
}
